export default function CheckCircelHoverIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_259_8512)">
        <rect
          x="0.835"
          y="0.835"
          width="18.33"
          height="18.33"
          rx="9.165"
          stroke="#344054"
          strokeWidth="1.67"
        />
      </g>
      <defs>
        <clipPath id="clip0_259_8512">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "CheckCircleHoverIcon";
